<h2>Lid worden</h2>
<p>Beste LETS-ge&iuml;nteresseerde,</p>
<p>Lid worden kan altijd &hellip; liefst nadat je een info-avond = infosessie meevolgde. <br>
We organiseren die ongeveer om de 2 maanden (afhankelijk van de interesse). <br>
Laat ons weten dat je graag uitgenodigd wordt ;-)</p>
<p>
    We vinden dit echt een voordeel omdat we dan onze streekeigen werking (met praktische voorbeelden en tips) en de werking met onze LetsC (beveiligde website waarop we alles kunnen vinden en regelen)     uitleggen, en omdat we dan jullie vragen daarover beantwoorden <br>
    &hellip; <br>
    zodat jullie daarna kunnen beslissen of jullie graag onze groep versterken als lid. <br>
Dit kan op de avond zelf als je graag snel begint, of later … ;-) <br>
(Het volgen van een infosessie houdt dus geen verplichting in, het aanvragen van info (onderaan) dus zeker niet.
</p>
<p>
    Met een beetje geluk leer je direct ook nieuwe LETSers kennen die avond.  
</p>
<p>
    In stapjes:
    <ul>
        <li>
        je laat ons weten dat je interesse hebt
    </li>
    <li>je krijgt alvast wat info</li>
    <li>je wordt uitgenodigd (tijdstip en adres) en volgt eens een infosessie</li>
    <li>als je lid wil worden vul je je gegevens in en schrijf je het lidgeld over (&euro;15/jaar voor lidgeld+verzekering voor werkenden, aangepaste tarieven voor wie (tijdelijk) geen werk heeft, meer info krijg je op de infosessie)</li>
    <li>je krijgt een account voor LetsC</li>
    <li>je krijgt ook 100 'ietsen' om mee te starten</li>
</ul>

<p>Vriendelijke groeten, en hopelijk tot ziens &hellip; of zelfs tot LETS ! ;-) </p>

